import { getRunstateText } from '@/utils/deviceUtils/state';

const alarmStatusMap = {
  0: '正常',
  1: '预警',
  2: '报警'
};

const runClass = {
  1: 'success-color',
  2: 'warning-color',
  3: 'danger-color'
};

const pump = {
  install: {
    0: '未安装',
    1: '已安装'
  },
  run: {
    0: '停止',
    1: '在线',
    2: '故障'
  },
  fault: {
    0: '无故障',
    1: '故障'
  },
  alarm: {
    0: '正常',
    1: '报警'
  },
  alarmClass: {
    0: 'success-color',
    1: 'danger-color'
  }
};

const runState = {
  0: '正常',
  1: '异常'
};

const alarmClassMap = {
  0: 'success-color',
  1: 'danger-color',
  2: 'danger-color'
};

const faultClassMap = {
  0: '',
  1: 'danger-color'
};

export const dict = {
  alarm: alarmStatusMap,
  pump,
  alarmClassMap,
  runState
};

export const tools = {
  alarmText(val) {
    return alarmStatusMap[val];
  },
  runText(val) {
    return getRunstateText(val);
  },
  pumpRunText(val) {
    return pump.run[val];
  },
  pumpInstallText(val) {
    return pump.install[val];
  },
  pumpAlarmText(val) {
    return pump.alarm[val];
  },
  pumpFaultText(val) {
    return pump.fault[val];
  },
  pumpFaultClass(val) {
    return faultClassMap[val];
  },
  alarmClass(val) {
    return alarmClassMap[val];
  },
  runClass(val) {
    return runClass[val];
  },
  pumpAlarmClass(val) {
    return pump.alarmClass[val];
  }
};
